import React from 'react';
import { BarCustomLayerProps } from '@nivo/bar/dist/types/types';
import { CartesianMarkerProps, useTheme } from '@nivo/core';
import { BarDatum } from '@nivo/bar';

export const AxisMarkersLayer = (props: BarCustomLayerProps<BarDatum>) => {
  const { width, height, innerHeight } = props;

  const chartMarkers: CartesianMarkerProps<number>[] = [
    {
      axis: 'x',
      value: 0,
      lineStyle: {
        stroke: '#292D33',
        strokeWidth: '1px',
      },
    },
    {
      axis: 'y',
      value: innerHeight,
      lineStyle: {
        stroke: '#292D33',
        strokeWidth: '1px',
      },
    },
  ];

  return chartMarkers.map((marker, i) => (
    <CartesianMarkersItem
      key={i}
      width={width}
      height={marker.axis === 'x' ? innerHeight : height}
      axis={marker.axis}
      scale={() => marker.value}
      lineStyle={marker.lineStyle}
    />
  ));
};

export const KeyFactorsAxisMarkersLayer = (
  props: BarCustomLayerProps<BarDatum>,
) => {
  const { width, height, innerHeight } = props;

  const y0 = props.yScale(0);

  const chartMarkers: CartesianMarkerProps<number>[] = [
    {
      axis: 'y',
      value: y0,
      lineStyle: {
        stroke: '#E7E8E8',
        strokeWidth: '1px',
      },
    },
    {
      axis: 'x',
      value: 0,
      lineStyle: {
        stroke: '#E7E8E8',
        strokeWidth: '1px',
      },
    },
  ];

  return chartMarkers.map((marker, i) => (
    <CartesianMarkersItem
      key={i}
      width={width}
      height={marker.axis === 'x' ? innerHeight : height}
      axis={marker.axis}
      scale={() => marker.value}
      lineStyle={marker.lineStyle}
    />
  ));
};

interface CartesianMarkersItemProps {
  width: number; // Total width of the chart area
  height: number; // Total height of the chart area
  axis: 'x' | 'y'; // The axis where the marker should be applied
  lineStyle?: React.CSSProperties; // Style for the marker line
  scale: () => number; // Scale function for the axis
}

const CartesianMarkersItem = ({
  width,
  height,
  axis,
  scale,
  lineStyle,
}: CartesianMarkersItemProps) => {
  const theme = useTheme();

  let x = 0;
  let x2 = 0;
  let y = 0;
  let y2 = 0;

  if (axis === 'y') {
    y = scale();
    x2 = width;
  } else {
    x = scale();
    y2 = height;
  }

  return (
    <g transform={`translate(${x}, ${y})`}>
      <line
        x1={0}
        x2={x2}
        y1={0}
        y2={y2}
        stroke={theme.markers.lineColor}
        strokeWidth={theme.markers.lineStrokeWidth}
        style={lineStyle}
      />
    </g>
  );
};
